module.exports = __webpack_public_path__ + "static/media/landfill.48b46943.svg";